import { Component, OnInit } from '@angular/core';
import { ISTATACARD, IS_CAMPAIGN, base_https_url } from 'src/app/config/app-settings.config';
import { ActivatedRoute, Router } from '@angular/router';
import { ThemeService } from 'src/app/services/theme.service';
import {CatalogueService} from 'src/app/services/catalogue.service'

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  TATACARD = ISTATACARD;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  domainUrl: any;
  
  IS_CAMPAIGN = IS_CAMPAIGN;
  partnerTheme: any;
  referralCodeJourneyEnabled: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private catalogueService :CatalogueService,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
    this.referralCodeJourneyEnabled = this.catalogueService.referralCode;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(query => {
      if(query.theme){
        this.partnerTheme = query.theme;
        // this.setThemeByParam(theme);
      }
    });
    this.domainUrl= base_https_url;
  }
  changeCardPartner(){
    this.router.navigate(['./catalogue-partner'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
  }
  changeCardRefer(){
    this.router.navigate(['./catalogue-refer'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
  }

}
